<template>
  <v-row class="pa-0 ma-0">
    <v-col cols="12" class="pa-0">
      <v-card flat color="transparent">
        <v-card-text class="py-0">
          <v-row align="center" justify="center" style="height:60px;">
            <v-col cols="6" class="pa-0" align="center">
              <v-row align="center" justify="start" class="ma-0 pa-0">
                <v-col cols="4" class="pa-0" align="center">
                </v-col>
                <v-col cols="2" class="pa-0" align="center">
                </v-col>
                <v-col cols="2" class="pa-0" align="center">
                </v-col>
                <v-col cols="2" class="pa-0" align="center">
                </v-col>
                <v-col cols="2" class="pa-0" align="center">
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6" class="pa-0">
              <v-row align="center" justify="start" class="ma-0 pa-0">
                <v-col cols="8" class="pa-0" align="center">
                </v-col>
                <v-col cols="4" class="pa-0" align="center">
                  <v-btn dark rounded depressed small color="primary" @click="item = null, dialog = true">
                    <span class="px-1 text-none">新規作成</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 py-0" align="center">
            <v-col cols="12" class="py-0 b-B" align="center">
              <v-row align="center" justify="center" style="height:48px;">
                <template v-for="(header, index) in headers">
                  <v-col :cols="header.width"  align="start" class="pa-0" :class="'customHeader'" :key="header.key">
                    <v-sheet class="pa-0" color="transparent">
                      <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                      <v-icon :color="headers[index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                    </v-sheet>
                  </v-col>
                </template>
                 <v-col class="pa-0" align="center">
                 </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pa-0" align="center">
              <div class='overflow-y-auto' :style="contentsHeight">
                <RecycleScroller
                  class="scroller"
                  :items="filterItems"
                  :item-size="44"
                  key-field="key"
                >
                  <template v-slot="{ item }">
                    <v-sheet :color="'transparent'" height="44" class="b-B-GREY">
                      <v-row class="ma-0 pa-0 customLine" align="center" @click="onSelect(item)">
                        <template v-for="(header) in headers">
                          <v-col :cols="header.width" class="pa-0" align="start" :key="header.key">
                            <template v-if="header.key == 'icon'">
                              <v-avatar>
                                <v-icon :color="getIconColor(item)">{{ getIcon(item) }}</v-icon>
                              </v-avatar>
                            </template>
                            <template v-else-if="header.key == 'typeName'">
                              <span class="overflow-text-hidden">{{ item[header.key] }}</span>
                            </template>
                            <template v-else-if="header.key == 'labelEnable'">
                              <v-chip small :color="item[header.key] == '公開' ? 'primary' : 'error'"><span >{{ item[header.key] }}</span></v-chip>
                            </template>
                            <template v-else>
                              <span class="overflow-text-hidden">{{ item[header.key] }}</span>
                            </template>
                          </v-col>
                        </template>
                        <v-col class="pa-0" align="center">
                          <v-btn small icon @click.stop="onRemoveDialog(item)" class="ma-0">
                            <v-icon color="error">mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-sheet>
                  </template>
                </RecycleScroller>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <div>
      <v-dialog
        v-model='dialog'
        persistent
        max-width="800px">
        <app-notice-edit
          v-if="dialog"
          @dismissed="onDismissed"
          :mode="'edit'"
          :item="item"
          :dialog='dialog'
        >
        </app-notice-edit>
      </v-dialog>
    </div>

    <div>
      <app-basic-dialog
        v-if='removeDialog'
        @dismissed="onDismissed"
        :title="'削除'"
        :message="'告知を削除します。よろしいですか?'"
        :dialog='removeDialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import NoticeEditDialog from '../../components/notice/NoticeEditDialog'
Vue.component('app-notice-edit', NoticeEditDialog)
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      notices: 'notices/notices',
      windowSize: 'shared/windowSize'
    }),
    filterItems () {
      var temp = []
      for (var i in this.notices) {
        if (this.notices[i].type === 3 && this.getPrivilegesLevel(this.data) !== 0) {
          continue
        }
        if (this.notices[i].type !== 3 && this.getPrivilegesLevel(this.data) === 0) {
          continue
        }
        var payload = {}
        moment.tz.setDefault('Asia/Tokyo')
        payload = JSON.parse(JSON.stringify(this.notices[i]))
        payload.typeName = this.getType(JSON.parse(JSON.stringify(this.notices[i])))
        payload.labelEnable = this.notices[i].enable ? '公開' : '非公開'
        payload.createdAt = moment(this.notices[i].createdAt).format('YYYY-MM-DD')
        payload.updatedAt = moment(this.notices[i].updatedAt).format('YYYY-MM-DD')
        temp.push(payload)
      }
      var key = null
      for (i in this.headers) {
        if (this.headers[i].value) {
          key = this.headers[i].key
          if (this.headers[i].value === 1) {
            temp.sort(function (a, b) {
              if (a[key] > b[key]) return -1
              if (a[key] < b[key]) return 1
              return 0
            })
          } else {
            temp.sort(function (a, b) {
              if (a[key] < b[key]) return -1
              if (a[key] > b[key]) return 1
              return 0
            })
          }
          break
        }
      }
      return temp
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 49 - 40) + 'px;'
    }
  },
  data () {
    return {
      loading: false,
      dialog: false,
      removeDialog: false,
      type: 1,
      item: null,
      search: null,
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ],
      headers: [
        { over: false, value: 0, title: '', key: 'icon', width: '1' },
        { over: false, value: 0, title: '種別', key: 'typeName', width: '2' },
        { over: false, value: 0, title: '名称', key: 'title', width: '5' },
        { over: false, value: 0, title: '状態', key: 'labelEnable', width: '1' },
        { over: false, value: 0, title: '更新日', key: 'updatedAt', width: '1' },
        { over: false, value: 0, title: '作成日', key: 'createdAt', width: '1' }
      ]
    }
  },
  methods: {
    getIconColor (item) {
      var index = this.$NOTICE_TYPE.findIndex(notie => notie.key === item.type)
      return this.$NOTICE_TYPE[index].color
    },
    getIcon (item) {
      var index = this.$NOTICE_TYPE.findIndex(notie => notie.key === item.type)
      return this.$NOTICE_TYPE[index].icon
    },
    getType (item) {
      var index = this.$NOTICE_TYPE.findIndex(type => type.key === item.type)
      if (index !== -1) {
        return this.$NOTICE_TYPE[index].name
      }
      return ''
    },
    getSortIcon (item) {
      return this.sortIcons[this.headers[item].value]
    },
    onMouse (item, value) {
      this.headers[item].over = value
    },
    onSelect (item) {
      var index = this.notices.findIndex(notice => notice.key === item.key)
      if (index !== -1) {
        this.item = JSON.parse(JSON.stringify(this.notices[index]))
        this.dialog = true
      }
    },
    onSort (item) {
      var temp = this.headers[item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in this.headers) {
        this.headers[i].value = 0
      }
      this.headers[item].value = temp
    },
    onRemoveDialog (item) {
      var index = this.notices.findIndex(notice => notice.key === item.key)
      if (index !== -1) {
        this.item = JSON.parse(JSON.stringify(this.notices[index]))
        this.removeDialog = true
      }
    },
    onRemove () {
      var vm = this
      this.removeDialog = false
      this.$nextTick(function () {
        this.loading = true
        var payload = vm.item.key
        vm.$store.dispatch('notices/delete', payload).then(() => {
          vm.item = null
          vm.loading = false
        })
      })
    },
    onDismissed: function (value) {
      if (this.removeDialog) {
        this.removeDialog = false
        if (value) {
          this.onRemove()
        }
        return
      }
      this.dialog = false
    }
  }
}
</script>

<style scoped>
.scroller {
  height: 100%;
}

.overflow-text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  user-select: none !important;
}

.b-B-GREY {
  border-bottom: 1px solid #EEEEEE80 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B-GREY-DARK {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.customHeader {
  cursor: pointer;
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}
</style>
